<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">Save Onboarding Preset</h4>
</div>

<div class="modal-body">
    <form [formGroup]="presetForm" (keydown)="onKeyPress($event)">
        <div class="form-group">
            <app-textbox 
                id="presetNameInput"
                caption="Preset Name"
                formControlName="presetName"
                [readonly]="false"
                [calculateValidationText]="getValidationText">
            </app-textbox>            
        </div>      
    </form>
</div>

<div class="modal-footer">
    <app-button appButtonPrimary [disabled]="!isFormValid" (click)="save()">Save Preset</app-button>
    <app-button appButtonSecondary (click)="cancel()">Cancel</app-button>
</div>